import React from "react";
// import WatchNowButton from "./WatchNowButton";
import ShowSocial from "./ShowSocial";
import ShowReviewQuote from "./ShowReviewQuote";

export default function ShowMeta({ showData }) {
  return (
    <>
      <ShowReviewQuote showData={showData} />
      <div className="d-flex flex-row flex-sm-column align-items-center justify-content-center gap-4">
        {/*<WatchNowButton showData={showData} />*/}
        <ShowSocial showData={showData} />
      </div>
    </>
  );
}
